import React, { ReactNode } from 'react';
import classNames from 'classnames';
import EFAmazon from 'elem/ui-assets/icons/unregular/EFAmazon';
import EfLink from '@elem/ui/ef-link';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';

interface NextGenInfoProps {
    className?: string;
    /** 标题 */
    title?: string;
    /** 基础信息 */
    infoList: {
        title: string;
        desc: string;
    }[];
    /* 促销信息 */
    alertInfo?: {
        icon: ReactNode;
        title: string;
    }[];
    /** 价格 */
    price?: string;

    amazonItem?: {
        startTime: string;
        endTime: string;
        href?: string;
    };

    /** buy now */
    buyNowItem?: {
        href?: string;
        text?: string;
    };
}

const NextGenInfo: React.FC<NextGenInfoProps> = ({ className, title, infoList, alertInfo, price, amazonItem, buyNowItem }) => {
    const { query } = useRouter();
    const { locale = 'eu' } = getLocal();
    const timer = query._timer ? new Date(query._timer as string) : new Date();
    const getTimeValue = (date: any, value: any) => {
        if (!date) return value; // 如果没有传入日期，则直接返回value
        const startTime = new Date(date.startTime);
        const endTime = new Date(date.endTime);
        if (timer < startTime) return null; // 未开始
        if (timer >= startTime && timer < endTime) return value; // 进行中
        if (timer > endTime) return null; // 已结束
    };
    return (
        <div className={classNames('ef-NextGen-info', className, styles.TheComp)}>
            {title && <div className="ef-NextGen-info-title">{title}</div>}
            <div className="ef-NextGen-info-list">
                {infoList.map((item) => (
                    <div className="ef-NextGen-info-item" key={item.title}>
                        <div className="ef-NextGen-info-item-title">{item.title}</div>
                        <div className="ef-NextGen-info-item-desc">{item.desc}</div>
                    </div>
                ))}
            </div>
            <div className="ef-NextGen-info-divider" />
            {price && <div className="ef-NextGen-info-price">{price}</div>}
            {alertInfo && alertInfo.length > 0 && locale !== 'us' && (
                <div className="ef-NextGen-info-alert">
                    {alertInfo.map((item, idx) => (
                        <div className="ef-NextGen-info-alert-item" key={idx}>
                            <span className="ef-NextGen-info-alert-icon">{item.icon}</span>
                            <span className="ef-NextGen-info-alert-text">{item.title}</span>
                        </div>
                    ))}
                </div>
            )}
            <div className="ef-NextGen-info-alert-btns">
                {amazonItem &&
                    getTimeValue(
                        amazonItem,
                        <EfLink className="ef-NextGen-info-amazon btn" href={amazonItem?.href}>
                            <span className="buy">Buy on</span>
                            <EFAmazon />
                        </EfLink>,
                    )}

                {buyNowItem && (
                    <EfLink
                        className="ef-NextGen-info-buyNow btn"
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'buy',
                            product_name: buyNowItem.text ?? 'Buy Now',
                            position: 'Product Detail',
                        }}
                        href={buyNowItem.href}
                    >
                        {buyNowItem.text ?? 'Buy Now'}
                    </EfLink>
                )}
            </div>
        </div>
    );
};
export default NextGenInfo;
